import { getClinicalDataApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

import { client } from '../client';
import { ClinicalDataPayload, ClinicalDataResponse, ObjectType } from './types/types';

export const updateClinicalData = async (
  object_type: ObjectType,
  object_id: string,
  payload: ClinicalDataPayload,
  userRole?: string,
): Promise<ClinicalDataResponse> => {
  const prefix = getClinicalDataApiPrefix(userRole);
  const path = prefix
    ? `${prefix}/clinical_data/${object_type}/${object_id}`
    : `/clinical-data/${object_type}/${object_id}`;
  try {
    const { data } = await client.put<ClinicalDataResponse>(path, payload);
    return data;
  } catch (error: any) {
    // Some staff-scoped clinical-data endpoints only allow PATCH for updates.
    if (error?.response?.status === 405) {
      const { data } = await client.patch<ClinicalDataResponse>(path, payload);
      return data;
    }
    throw error;
  }
};
